module.exports = {"TXTCLI_Invalid_date":{"id":"TXTCLI_Invalid_date","defaultMessage":"Μη Έγκυρη Ημερομηνία","track":"Invalid date"}}